module.exports = __webpack_public_path__ + "assets/img/map_1.c5210b9c.svg";